import { handleActions } from 'redux-actions';
import { fetchDetailedOffersRequest, fetchDetailedOffersResponse } from 'shared/store/modules/offers/actions';

export default handleActions(
  {
    [fetchDetailedOffersRequest]: () => true,
    [fetchDetailedOffersResponse]: () => false
  },
  false
);
